/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { RegistrationType } from '../../../app/enums/registration-type'

export const legalConditionsData = [
  {
    ciamVersion: 'PorscheConnectDPG/DE/de_DE/v3.17',
    shopVersion: 'v3.17',
    type: 'DPG',
    linkPDF: 'https://terms.porsche-preview.com/medias/de/de-DE/Data_Privacy_Guideline.pdf',
    linkExt: 'https://terms.porsche-preview.com/de/de-DE/privacy',
  },
  {
    ciamVersion: 'PorscheConnectTAC/DE/de_DE/v1.41',
    shopVersion: 'v1.41',
    type: 'TAC',
    linkPDF: 'https://terms.porsche-preview.com/medias/de/de-DE/Terms_and_Conditions.pdf',
  },
  {
    ciamVersion: 'PorscheConnectTOU/DE/de_DE/v3.24',
    shopVersion: 'v3.24',
    type: 'TOU',
    linkPDF: 'https://terms.porsche-preview.com/medias/de/de-DE/Terms_of_Use.pdf',
  },
]

export const ownerTransactionValidationData = {
  type: 'OWNER',
  ciamId: 'ajs6npnmvny23yc8',
  porscheId: 'myPorscheId@myprofile.id',
  needsSpin: true,
  vin: 'BPOPIDE3PP0000169',
  authOptions: [{ type: 'SMS', confirmed: false, hint: '+49******4721' }],
  vehicle: { isConnectable: true, baseModel: 'taycan' },
  registrationType: RegistrationType.EMAIL,
}

export const vehicleTransactionValidationData = {
  type: 'VEHICLE',
  ciamId: 'ajs6npnmvny23yc8',
  porscheId: 'myPorscheId@myprofile.id',
  simplified: false,
  needsSpin: true,
  mobile: '*****123',
  trialAvailable: true,
  authOptions: [{ type: 'SMS', confirmed: false, hint: '+49******4721' }],
  vehicle: { isConnectable: true },
  registrationType: RegistrationType.EMAIL,
}

export const simplifiedVehicleTransactionValidationData = {
  type: 'VEHICLE',
  ciamId: 'ajs6npnmvny23yc8',
  porscheId: 'myPorscheId@myprofile.id',
  simplified: true,
  needsSpin: true,
  mobile: '*****123',
  trialAvailable: true,
  authOptions: [{ type: 'SMS', confirmed: false, hint: '+49******4721' }],
  vehicle: { isConnectable: true },
  registrationType: RegistrationType.EMAIL,
}

export const simplifiedVehicleTransactionValidationDataMobile = {
  type: 'VEHICLE',
  ciamId: 'ajs6npnmvny23yc8',
  porscheId: 'myPorscheId@myprofile.id',
  simplified: true,
  needsSpin: true,
  mobile: '*****123',
  trialAvailable: true,
  authOptions: [{ type: 'SMS', confirmed: false, hint: '+49******4721' }],
  vehicle: { isConnectable: true },
  registrationType: RegistrationType.MOBILE,
}

export const prospectTransactionValidationData = {
  type: 'PROSPECT',
  authOptions: [],
  ciamId: 'noshbwztssan0cws',
  porscheId: 'some-porsche-id@pid.com',
  needsSpin: false,
  registrationType: RegistrationType.EMAIL,
}

export const trackYourDreamTransactionValidationData = {
  type: 'TRACK_YOUR_DREAM',
  authOptions: [],
  ciamId: 'noshbwztssan0cws',
  porscheId: 'some-porsche-id@pid.com',
  needsSpin: false,
  registrationType: RegistrationType.EMAIL,
}

export const ownerMobileTransactionValidationData = {
  type: 'OWNER',
  ciamId: 'ajs6npnmvny23yc8',
  porscheId: '+491234564721',
  needsSpin: true,
  vin: 'BPOPIDE3PP0000169',
  authOptions: [{ type: 'SMS', confirmed: false, hint: '+49******4721' }],
  vehicle: { isConnectable: true },
  registrationType: RegistrationType.MOBILE,
}

export const secondaryTransactionValidationData = {
  type: 'SECONDARY',
  ciamId: 'ajs6npnmvny23yc8',
  porscheId: 'myPorscheId@myprofile.id',
  needsSpin: true,
  vin: 'BPOPIDE3PP0000169',
  authOptions: [{ type: 'SMS', confirmed: false, hint: '+49******4721' }],
  vehicle: { isConnectable: true },
  registrationType: RegistrationType.EMAIL,
}

export const secondaryTransactionValidationDataMobile = {
  type: 'SECONDARY',
  ciamId: 'ajs6npnmvny23yc8',
  porscheId: '+4920508480896',
  dateOfBirth: '10101991',
  needsSpin: true,
  vin: 'BPOPIDE3PP0000169',
  authOptions: [{ type: 'DOB', confirmed: false, hint: '*******' }],
  vehicle: { isConnectable: true },
  registrationType: RegistrationType.MOBILE,
}

export const secondaryVehicleTransactionValidationData = {
  type: 'SECONDARY_VEHICLE',
  ciamId: 'ajs6npnmvny23yc8',
  porscheId: 'myPorscheId@myprofile.id',
  needsSpin: true,
  vin: 'BPOPIDE3PP0000169',
  authOptions: [{ type: 'SMS', confirmed: false, hint: '+49******4721' }],
  vehicle: { isConnectable: true },
  registrationType: RegistrationType.EMAIL,
}

export const organisationTransactionValidationData = {
  type: 'ORGANISATION',
  authOptions: [],
  ciamId: 'noshbwztssan0cws',
  porscheId: 'some-porsche-id@pid.com',
  needsSpin: false,
  registrationType: RegistrationType.EMAIL,
}

export const encryptionKeysData = {
  keys: [
    {
      kty: 'RSA',
      e: 'AQAB',
      use: 'enc',
      kid: 'cdaab3fc-0122-42d1-93c4-1eb3733138b2',
      n: 'mren3XUpYnh1Gh5QDZCrpKmSTuRkl-0u9qY6MVJwN67P_e5BI6m7l6ZmlSkjsb21rXpCp5n7wzGQeYZlq1hURwQcrfj2wxXmR6-iHrnWyg0lT4eL8tZOjtBVSI4tA4x8oVsol-f3jGVjgPZizPoSsKzkKw1yw40IvRAJq-XAdg42Ehoe1HxfLGBz7Km9FqFtFbi-xg6J7ZPEjMZruIqgQLod70P3xPV1NN5zqMyNTxsBY3TvLmVlq8IAZgXeo4ebd8-hcXkNs4SrYYpd-MVZBFU6-qYmEzT19iMLDoYvzXddfpu9nSIm2KIT_vI7i4GJXndLKLpp9PxO89S5mKRtxw',
    },
  ],
}

export const confirmationResponseData = {
  cookies: [],
  redirectUrl: 'http://localhost:4200/',
  serviceActivationAvailable: true,
  accessToken: 'TOKEN',
}

export const organisationContactInformation = [
  {
    id: '4a180ee0-42c5-11e6-b1c1-9c0b544e6529',
    email: 'smartmobility@de.porsche.com',
    telephoneNumber: '+49 711 91175500',
    companyName: 'Contact Porsche',
    displayName: 'Porsche Connect Support Germany',
  },
]

export const featureTogglesData = [
  {
    featureName: 'register_with_mobile_number',
    active: true,
  },
]

export const verifyTransactionIdData = {
  tid: '_prospect',
  otp: 'non-connect',
}
